import { ChangeDetectionStrategy, Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TagPusherService } from '@libs/shared-services';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { filter } from 'rxjs';
import { LocalizationService } from './services';

@Component({
  imports: [RouterModule, GoogleTagManagerModule],
  selector: 'ffd-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated,
})
export class AppComponent implements OnInit {
  private readonly localizationService = inject(LocalizationService);
  private readonly tagPusherService = inject(TagPusherService);
  private readonly router = inject(Router);

  public ngOnInit(): void {
    this.localizationService.init();
    this.tagPusherService.init();
    this.trackPageViewsForHubspot();
  }

  private trackPageViewsForHubspot(): void {
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
      if (typeof window !== 'undefined' && window._hsq) {
        this.refreshHubSpotCallsToActions();
      }
    });
  }

  private refreshHubSpotCallsToActions(): void {
    try {
      window?.HubSpotCallsToActions?.refresh();
    } catch (error) {
      console.warn('HubSpot Calls to Actions is not available', error);
    }
  }
}
